export default __webpack_public_path__ + "static/media/emoji-messagerie.af2d47c3.svg";